import LogoProyecto from './../UI/svg/Cassia.svg'

import i_back_simple from '../UI/back_simple.png';
import i_close from '../UI/Close.png';
import i_back from '../UI/svg/Volver.svg';
import i_vias from '../UI/svg/Vias.svg';
import i_zonas_interes from '../UI/svg/Puntos-interes.svg';
import i_amenidades from '../UI/svg/Amenities.svg';
import i_etapas from '../UI/svg/Proyecto.svg';
import i_vias2 from '../UI/svg/Vias2.svg';
import i_zonas_interes2 from '../UI/svg/Puntos-interes2.svg';
import i_amenidades2 from '../UI/svg/Amenities2.svg';
import i_etapas2 from '../UI/svg/Proyecto2.svg';



import i_360 from '../UI/svg/360.svg';
import i_d_vend from '../UI/vendido.png';
import i_d_res from '../UI/reservado.png';
import i_d_disp from '../UI/disponible.png';
import i_proyectos from "../UI/svg/building.svg";
import i_proyectos2 from "../UI/svg/building2.svg";
import i_renders from "../UI/svg/renders.svg";
import i_videos from "../UI/svg/video.svg";

/* Puntos de interés */

import i_educacion from '../UI/svg/beneficios/Educacion.svg';
import i_educacion2 from '../UI/svg/beneficios/Educacion2.svg';
import i_comercio from '../UI/svg/beneficios/Comercio.svg';
import i_comercio2 from '../UI/svg/beneficios/Comercio2.svg';
import i_parques from '../UI/svg/beneficios/Parques.svg';
import i_parques2 from '../UI/svg/beneficios/Parques2.svg';
import i_salud from '../UI/svg/beneficios/Salud.svg';
import i_salud2 from '../UI/svg/beneficios/Salud2.svg';
import i_discoteca from '../UI/svg/beneficios/Discoteca.svg';
import i_discoteca2 from '../UI/svg/beneficios/Discoteca2.svg';
import i_hotel from './../UI/svg/amenities/hotel.svg'
import i_hotel2 from './../UI/svg/amenities/hotel2.svg'
import i_restaurantes from './../UI/svg/amenities/restaurantes.svg'
import i_restaurantes2 from './../UI/svg/amenities/restaurantes2.svg'
import i_quebradas from './../UI/svg/amenities/quebradas.svg'
import i_quebradas2 from './../UI/svg/amenities/quebradas2.svg'
import i_supermercados from './../UI/svg/beneficios/distrito/supermercados.svg'
import i_supermercados2 from './../UI/svg/beneficios/distrito/supermercados2.svg'


/* Amenidades */
import i_lobby from './../UI/svg/amenities/Lobby.svg'
import i_lobby2 from './../UI/svg/amenities/Lobby2.svg'
import i_gym from './../UI/svg/amenities/Gym.svg'
import i_gym2 from './../UI/svg/amenities/Gym2.svg'
import i_petpark from './../UI/svg/amenities/PetPark.svg'
import i_petpark2 from './../UI/svg/amenities/PetPark2.svg'
import i_terrace from './../UI/svg/amenities/Terrace.svg'
import i_terrace2 from './../UI/svg/amenities/Terrace2.svg'
import i_solarium from './../UI/svg/amenities/Solarium.svg'
import i_solarium2 from './../UI/svg/amenities/Solarium2.svg'
import i_coworking from './../UI/svg/amenities/Coworking.svg'
import i_coworking2 from './../UI/svg/amenities/Coworking2.svg'
import i_jacuzzi from './../UI/svg/amenities/Jacuzzi.svg'
import i_jacuzzi2 from './../UI/svg/amenities/Jacuzzi2.svg'
import i_yoga from './../UI/svg/amenities/Yoga.svg'
import i_yoga2 from './../UI/svg/amenities/Yoga2.svg'
import i_playground from './../UI/svg/amenities/Playground.svg'
import i_playground2 from './../UI/svg/amenities/Playground2.svg'
import i_pool from './../UI/svg/amenities/Pool.svg'
import i_pool2 from './../UI/svg/amenities/Pool2.svg'
import i_commercial from './../UI/svg/amenities/CommercialArea.svg'
import i_commercial2 from './../UI/svg/amenities/CommercialArea2.svg'
import i_bbq from './../UI/svg/amenities/BBQ.svg'
import i_bbq2 from './../UI/svg/amenities/BBQ2.svg'
import i_laundry from './../UI/svg/amenities/Laundry.svg'
import i_laundry2 from './../UI/svg/amenities/Laundry2.svg'
import i_hall from './../UI/svg/amenities/Hall.svg'
import i_hall2 from './../UI/svg/amenities/Hall2.svg'
import i_rancho from './../UI/svg/amenities/rancho.svg'
import i_rancho2 from './../UI/svg/amenities/rancho2.svg'
import i_caballerizas from './../UI/svg/amenities/caballerizas.svg'
import i_caballerizas2 from './../UI/svg/amenities/caballerizas2.svg'

import i_Artes from './../UI/svg/amenities/distrito/Artes.svg'
import i_Artes2 from './../UI/svg/amenities/distrito/Artes2.svg'
import i_Cancha from './../UI/svg/amenities/distrito/Cancha.svg'
import i_Cancha2 from './../UI/svg/amenities/distrito/Cancha2.svg'
import i_Cinema from './../UI/svg/amenities/distrito/Cinema.svg'
import i_Cinema2 from './../UI/svg/amenities/distrito/Cinema2.svg'
import i_Hobbies from './../UI/svg/amenities/distrito/Hobbies.svg'
import i_Hobbies2 from './../UI/svg/amenities/distrito/Hobbies2.svg'
import i_Playground from './../UI/svg/amenities/distrito/Playground.svg'
import i_Playground2 from './../UI/svg/amenities/distrito/Playground2.svg'
import i_Saloncomunal from './../UI/svg/amenities/distrito/Saloncomunal.svg'
import i_Saloncomunal2 from './../UI/svg/amenities/distrito/Saloncomunal2.svg'


/* guided tour */
import lock_on from './../UI/svg/guided-tour/lock-on.svg'
import lock_off from './../UI/svg/guided-tour/lock-off.svg'
import follow_on from './../UI/svg/guided-tour/follow-on.svg'
import follow_off from './../UI/svg/guided-tour/follow-off.svg'
import hangup from './../UI/svg/guided-tour/hangup.svg'
import video_on from './../UI/svg/guided-tour/video-on.svg'
import video_off from './../UI/svg/guided-tour/video-off.svg'
import mic_on from './../UI/svg/guided-tour/mic-on.svg'
import mic_off from './../UI/svg/guided-tour/mic-off.svg'
import x from './../UI/svg/guided-tour/x.svg'
import arrow_down from './../UI/svg/guided-tour/arrow-down.svg'


export default {
    'Back': i_back,
    'Close': i_close,
    'logo-proyecto': LogoProyecto,
    'Back simple': i_back_simple,
    'Vías': i_vias,
    'ZonasDeInterés': i_zonas_interes,
    'Amenidades': i_amenidades,
    'Etapas': i_etapas,
    'Vías2': i_vias2,
    'ZonasDeInterés2': i_zonas_interes2,
    'Amenidades2': i_amenidades2,
    'Etapas2': i_etapas2,
    'Proyectos': i_proyectos,
    'Proyectos2': i_proyectos2,
    '360': i_360,
    'VENDIDO': i_d_vend,
    'RESERVADO': i_d_res,
    'DISPONIBLE': i_d_disp,
    'Renders': i_renders,
    'Videos': i_videos,
    /* Amenidades */
    "Portería 1": i_lobby,
    "Portería 12": i_lobby2,
    "Portería 2": i_lobby,
    "Portería 22": i_lobby2,
    "Gimnasio": i_gym,
    "Gimnasio2": i_gym2,
    "Pet Zone": i_petpark,
    "Pet Zone2": i_petpark2,
    "Eco Terrace": i_terrace,
    "Eco Terrace2": i_terrace2,
    "Solarium": i_solarium,
    "Solarium2": i_solarium2,
    "Co-working": i_coworking,
    "Co-working2": i_coworking2,
    "Jacuzzi View": i_jacuzzi,
    "Jacuzzi View2": i_jacuzzi2,
    "Yoga Deck": i_yoga,
    "Yoga Deck2": i_yoga2,
    "Juegos Infantiles": i_playground,
    "Juegos Infantiles2": i_playground2,
    "Piscina Adultos y Niños": i_pool,
    "Piscina Adultos y Niños2": i_pool2,
    "Children's Pool": i_pool,
    "Children's Pool2": i_pool2,
    "Commercial Area": i_commercial,
    "Commercial Area2": i_commercial2,
    "BBQ": i_bbq,
    "BBQ2": i_bbq2,
    "Laundry": i_laundry,
    "Laundry2": i_laundry2,
    "Hall": i_hall,
    "Hall2": i_hall2,
    "Rancho": i_rancho,
    "Rancho2": i_rancho2,
    "Caballerizas": i_caballerizas,
    "Caballerizas2": i_caballerizas2,

    "Taller Artes": i_Artes,
    "Taller Artes2": i_Artes2,
    "Salón Hobbies": i_Hobbies,
    "Salón Hobbies2": i_Hobbies2,
    "Cancha Fútbol 5": i_Cancha,
    "Cancha Fútbol 52": i_Cancha2,
    "Playground": i_Playground,
    "Playground2": i_Playground2,
    "Sala de Cine": i_Cinema,
    "Sala de Cine2": i_Cinema2,
    "Salón Social": i_Saloncomunal,
    "Salón Social2": i_Saloncomunal2,

    /* Puntos de interés */
    'Educación': i_educacion,
    'Educación2': i_educacion2,
    'Comercio': i_comercio,
    'Comercio2': i_comercio2,
    'Parques': i_parques,
    'Parques2': i_parques2,
    'Salud': i_salud,
    'Salud2': i_salud2,
    'Discotecas': i_discoteca,
    'Discotecas2': i_discoteca2,
    'Hotel': i_hotel,
    'Hotel2': i_hotel2,
    'Restaurantes': i_restaurantes,
    'Restaurantes2': i_restaurantes2,
    'Quebradas': i_quebradas,
    'Quebradas2': i_quebradas2,
    'Supermercados': i_supermercados,
    'Supermercados2': i_supermercados2,

    /* guided tour */
    'lock_on': lock_on,
    'lock_off': lock_off,
    'follow_on': follow_on,
    'follow_off': follow_off,
    'hangup': hangup,
    'video_on': video_on,
    'video_off': video_off,
    'mic_on': mic_on,
    'mic_off': mic_off,
    'x': x,
    'arrow_down': arrow_down
}